import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../admin/api';
import Icon from '../../admin/Icon';
import '../../admin/admin.css';

const AcceptInvite = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [state, setState] = useState('loading'); // loading | ready | invalid | done
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState('invalid'); return; }
    api.getInvite(token)
      .then((d) => { setEmail(d.email); setState('ready'); })
      .catch((err) => { setError(err.message); setState('invalid'); });
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setBusy(true);
    try {
      await api.acceptInvite(token, password);
      setState('done');
      setTimeout(() => navigate('/portal/login', { replace: true }), 2200);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <img src="/assets/logo.png" alt="JG Detailing" className="brand-logo" onError={(e) => { e.target.style.display = 'none'; }} />
          <p className="admin-login-sub">Shop Manager Setup</p>
        </div>

        {state === 'loading' && <p className="admin-login-foot">Checking your invite…</p>}

        {state === 'invalid' && (
          <>
            <p className="admin-error" style={{ textAlign: 'center' }}>{error || 'This invite is invalid or has expired.'}</p>
            <button className="admin-ghost-btn" onClick={() => navigate('/portal/login')}>Go to sign in</button>
          </>
        )}

        {state === 'done' && (
          <p className="admin-login-foot" style={{ fontSize: 14 }}>
            <Icon name="check-circle" size={15} /> Your account is ready! Redirecting you to sign in…
          </p>
        )}

        {state === 'ready' && (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="admin-field">
              <label>Email</label>
              <input value={email} disabled />
            </div>
            <div className="admin-field">
              <label>Create password</label>
              <div className="admin-input-wrap">
                <input
                  type={showPw ? 'text' : 'password'}
                  value={password}
                  autoFocus
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="At least 6 characters"
                />
                <button type="button" className="pw-toggle" onClick={() => setShowPw((v) => !v)}>
                  {showPw ? <Icon name="eye-off" size={17} /> : <Icon name="eye" size={17} />}
                </button>
              </div>
            </div>
            <div className="admin-field">
              <label>Confirm password</label>
              <input
                type={showPw ? 'text' : 'password'}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Re-enter password"
              />
            </div>

            {error && <p className="admin-error" style={{ textAlign: 'center' }}>{error}</p>}

            <button type="submit" className="admin-primary-btn admin-login-btn" disabled={busy || !password || !confirm}>
              {busy ? 'Setting up…' : 'Activate account'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;
